var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "53px",
    viewBox: "0 0 53 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_Trash 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kiosko",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Carro-A-2",
    transform: "translate(-1119, -2157)",
    fill: "#414042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1080, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trash",
    transform: "translate(39, 2157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53,8.48 L53,10.6 L46.64,10.6 L46.64,50.35 C46.64,51.8128 45.4528,53 43.99,53 L9.01,53 C7.5472,53 6.36,51.8128 6.36,50.35 L6.36,10.6 L0,10.6 L0,8.48 L16.96,8.48 L16.96,2.65 C16.96,1.1872 18.1472,0 19.61,0 L33.39,0 C34.8528,0 36.04,1.1872 36.04,2.65 L36.04,8.48 L53,8.48 Z M33.92,40.28 L31.8,40.28 L31.8,21.2 L33.92,21.2 L33.92,40.28 Z M33.92,8.48 L19.08,8.48 L19.08,2.65 C19.08,2.3532 19.3132,2.12 19.61,2.12 L33.39,2.12 C33.6868,2.12 33.92,2.3532 33.92,2.65 L33.92,8.48 Z M44.52,10.6 L8.48,10.6 L8.48,50.35 C8.48,50.6468 8.7132,50.88 9.01,50.88 L43.99,50.88 C44.2868,50.88 44.52,50.6468 44.52,50.35 L44.52,10.6 Z M19.08,21.2 L21.2,21.2 L21.2,40.28 L19.08,40.28 L19.08,21.2 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.da8b99b98914ccf123fff5e22a14bda3.svg";
export { ForwardRef as ReactComponent };